/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DocumentDetailsRequestDTO } from './DocumentDetailsRequestDTO';

export type BusinessDetailsGhanaDTO = {
    businessName?: string;
    businessTradingName?: string;
    businessType?: BusinessDetailsGhanaDTO.businessType;
    documents?: Array<DocumentDetailsRequestDTO>;
    verificationStatus?: BusinessDetailsGhanaDTO.verificationStatus;
};

export namespace BusinessDetailsGhanaDTO {

    export enum businessType {
        INTERNATIONAL_PASSPORT = 'INTERNATIONAL_PASSPORT',
        VOTERS_CARD = 'VOTERS_CARD',
        NATIONAL_ID_CARD = 'NATIONAL_ID_CARD',
        DRIVERS_LICENSE = 'DRIVERS_LICENSE',
        ECG_GHANA_ELECTRICITY = 'ECG_GHANA_ELECTRICITY',
        TELEPHONE_BILL = 'TELEPHONE_BILL',
        GHANA_WATER_BILL = 'GHANA_WATER_BILL',
        SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
        PARTNERSHIP = 'PARTNERSHIP',
        LIMITED_UNLIMITED_LIABILITY = 'LIMITED_UNLIMITED_LIABILITY',
        EXTERNAL_COMPANY = 'EXTERNAL_COMPANY',
        LIMITED_LIABILITY = 'LIMITED_LIABILITY',
        CLUBS_SOCIETIES_ASSOCIATIONS = 'CLUBS_SOCIETIES_ASSOCIATIONS',
        GHANA_CARD = 'GHANA_CARD',
        HOME_ADDRESS = 'HOME_ADDRESS',
        DIRECTORS_NAME = 'DIRECTORS_NAME',
        RESIDENT_PERMIT = 'RESIDENT_PERMIT',
        NON_CITIZEN_CARD = 'NON_CITIZEN_CARD',
        GIPC_CERTIFICATE = 'GIPC_CERTIFICATE',
        SELFIE = 'SELFIE',
        BVN = 'BVN',
    }

    export enum verificationStatus {
        PENDING = 'PENDING',
        SUCCESS = 'SUCCESS',
        FAILED = 'FAILED',
    }


}

